import { Box } from '@hivebrite/design-system/Box';
import { SliderWithTitle } from '@hivebrite/design-system/Slider';
import { toast } from '@hivebrite/design-system/Toast';

import { useLiveFeedContext } from 'hb-react/frontoffice/apps/LiveFeed/contexts/LiveFeedContext';
import { useTopPostsContext } from 'hb-react/frontoffice/apps/LiveFeed/contexts/TopPostsContext';
import useOutboxedFontTheme from 'hb-react/shared/hooks/theme/useOutboxedFontTheme';
import { amplitudeLogger } from 'hb-react/shared/utils/amplitude';
import ThemeProvider from 'hb-react/style/ThemeProvider';

import LoadingCard from './LoadingCard';
import PostCardContainer from './PostCardContainer';

const TopPosts = () => {
  const outboxedFontTheme = useOutboxedFontTheme();
  const { amplitudeConfig } = useLiveFeedContext();
  const { isLoading, error, totalItems, topPosts, onLoadMore } =
    useTopPostsContext();
  const amplitude = amplitudeLogger(amplitudeConfig);

  const onShowNext = () => {
    amplitude.track('LiveFeed|ScrolledThroughTopPosts');
  };

  if (error) {
    toast.error(__('Sorry, an error occurred'));

    return null;
  }

  if (!isLoading && topPosts.length === 0) {
    return null;
  }

  return (
    <Box
      flexDirection="column"
      alignItems="center"
      overflow="hidden"
      data-testid="top-posts"
    >
      <Box
        flexDirection="column"
        pt={6}
        mb={7}
        px={{
          _: 4,
          m: 0,
        }}
        width={{
          s: '100%',
          m: '597px',
          l: '960px',
          xl: '1144px',
        }}
      >
        <ThemeProvider
          theme="fo"
          fontBrightness={outboxedFontTheme.fontBrightness}
        >
          <Box flexDirection="column">
            <SliderWithTitle
              items={topPosts}
              total={totalItems}
              title={s__('LiveFeed|Top posts')}
              titleAs="h2"
              titleFont="h3-semibold"
              perPageBreakpoints={SLIDER_CARDS_PER_ROW}
              ItemComponent={PostCardContainer}
              LoadingItemComponent={LoadingCard}
              loading={isLoading}
              onLoadMore={onLoadMore}
              afterSlide={(index) => {
                if (index > 0) {
                  onShowNext();
                }
              }}
            />
          </Box>
        </ThemeProvider>
      </Box>
    </Box>
  );
};

export default TopPosts;

const SLIDER_CARDS_PER_ROW = {
  s: 1,
  m: 3,
  l: 4,
  xl: 4,
};
